<template>
    <div class="main__learner__data__section common__page__box">
        <section class="rlms-container">
            <div class="group__box__wrappers">
                <div class="dashboard__content__box">
                    <!-- Learners List (Desktop) -->
                    <div class="learners__data__box">
                        <div class="section__title__box">
                            <h4 class="title">Learners</h4>
                            <div class="rlms-table-filters">
                                <div class="scrollable-container">
                                    <div class="head__title__wrap">
                                        <div class="title__select__box">
                                            <select class="select" v-model="filter.type" @change="fetchData()">
                                                <option value="all">All Learners</option>
                                                <option value="active">Active Learners</option>
                                                <option value="inactive">Inactive Learners</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="rlms-tf-actions">
                                    <div class="input-icon-group input-icon-right">
                                        <input type="search" placeholder="Search..." v-model="filter.search"
                                            @input="handleSearch" />
                                        <img class="rlms-input-icon" :src="searchIcon">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="learner__details__box rlms-w-100" v-if="loading">
                            <div class="learner__head__box">
                                <span class="head__title">Learner</span>
                                <span class="head__title">Organization</span>
                                <span class="head__title">Gender</span>
                                <span class="head__title info__popup__wrap">
                                    Subscription
                                    <i><img :src="dangerIcon" alt="Info" /></i>
                                </span>
                                <span class="head__title">Progress</span>
                                <span class="head__title">Action</span>
                            </div>

                            <div class="divider__sepline"></div>
                            <div class="rlms-w-100">
                                <SkeletonLoader />
                            </div>
                        </div>
                        <template v-else>
                            <div class="rlms-w-100" :class="{
                                'learner__details__box': !isMobile
                            }">
                                <!-- Table Headers -->
                                <template v-if="!isMobile">
                                    <div class="learner__head__box">
                                        <span class="head__title">Learner</span>
                                        <span class="head__title">Organization</span>
                                        <span class="head__title">Gender</span>
                                        <span class="head__title info__popup__wrap">
                                            Subscription
                                            <i><img :src="dangerIcon" alt="Info" /></i>
                                        </span>
                                        <span class="head__title">Progress</span>
                                        <span class="head__title">Action</span>
                                    </div>

                                    <div class="divider__sepline"></div>
                                </template>

                                <!-- Learners List -->
                                <div class="card__tablist__box" v-if="learners.length" :class="{
                                    'rlms-flex rlms-flex-col rlms-gap-30': isMobile
                                }" :style="!isMobile ? { height: 'auto' } : {}">
                                    <template v-if="isMobile">
                                        <div class="mob__learner__details__block rlms-flex rlms-flex-col rlms-gap-30">
                                            <div class="mob__table__header">
                                                <div class="table__head__item">
                                                    Learner
                                                </div>
                                                <div class="table__head__item">
                                                    Subscription
                                                    <img :src="dangerIcon" alt="Info" />
                                                </div>
                                                <div class="table__head__item">
                                                    Action
                                                </div>
                                            </div>
                                            <div class="mob__learner__details__card__list" style="max-height: 100dvh;">
                                                <!-----learner Card item------->
                                                <div class="mob__learner__details__item" v-for="learner in learners"
                                                    :key="learner.id">
                                                    <div class="inner__learner__info">
                                                        <span class="learner__avatar__img">
                                                            <img :src="learner.picture || learnerIcon"
                                                                alt="Learner Profile" />
                                                        </span>
                                                        <div class="learner__personal__info">
                                                            <div class="learner__name__status">
                                                                <h6 class="name rlms-flex rlms-gap-10">{{
                                                                    learner.firstname }} {{
                                                                        learner.lastname
                                                                    }}
                                                                    <template
                                                                        v-if="!learner.is_owner && learner?.is_administrator">
                                                                        <Tooltip
                                                                            :content="`<p class='rlms-p-3'>Administrator Access</p>`"
                                                                            placement="bottom">
                                                                            <template #button>
                                                                                <img :src="optionsInfoIcon" />
                                                                            </template>
                                                                        </Tooltip>
                                                                    </template>
                                                                    <template
                                                                        v-else-if="!learner.is_owner && !learner?.is_administrator && learner?.is_authorized_user">
                                                                        <Tooltip
                                                                            :content="`<p class='rlms-p-3'>Group Access</p>`"
                                                                            placement="right">
                                                                            <template #button>
                                                                                <img :src="optionsInfoIcon" />
                                                                            </template>
                                                                        </Tooltip>
                                                                    </template>
                                                                </h6>
                                                                <span v-if="learner.subscription_status === null"
                                                                    class="status_label rlms-bg-danger-400">No
                                                                    Subscription</span>
                                                                <span v-else-if="learner.subscription_status"
                                                                    class="status_label active">Active</span>
                                                                <span v-else
                                                                    class="status_label rlms-bg-danger-400">Expired</span>
                                                            </div>
                                                            <div class="mob__learn__more">
                                                                <RouterLink
                                                                    :to="`organizations/${learner.organization_id}/learners/${learner.id}/dashboard`">
                                                                    <img :src="learnMoreIcon">
                                                                </RouterLink>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="learner__user__progress__bar">
                                                        <div class="progress__bar__title">
                                                            <label class="progress__label">Progress</label>
                                                            <span class="progress__percent">{{ learner?.progress ?? 0
                                                                }}%</span>
                                                        </div>
                                                        <div class="learner__progress">
                                                            <div class="default__progressbar">
                                                                <span class="progressbar__filler"
                                                                    :style="{ width: (learner?.progress ?? 0) + '%' }"></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div v-for="learner in learners" :key="learner.id" class="tablist__item">
                                            <!-- Learner Name and Profile -->
                                            <div class="learner__tab">
                                                <div class="learner__profile">
                                                    <img :src="learner.picture || learnerIcon" alt="Learner Profile" />
                                                </div>
                                                <h6 class="learner__name">{{ learner.firstname }} {{ learner.lastname }}
                                                </h6>
                                                <template v-if="!learner.is_owner && learner?.is_administrator">
                                                    <Tooltip :content="`<p class='rlms-p-3'>Administrator Access</p>`"
                                                        placement="bottom">
                                                        <template #button>
                                                            <img :src="optionsInfoIcon" />
                                                        </template>
                                                    </Tooltip>
                                                </template>
                                                <template
                                                    v-else-if="!learner.is_owner && !learner?.is_administrator && learner?.is_authorized_user">
                                                    <Tooltip :content="`<p class='rlms-p-3'>Group Access</p>`"
                                                        placement="right">
                                                        <template #button>
                                                            <img :src="optionsInfoIcon" />
                                                        </template>
                                                    </Tooltip>
                                                </template>
                                            </div>
                                            <div class="learner__tab">
                                                <h6 class="learner__name">{{ learner?.organization?.name ?? '-' }}</h6>
                                            </div>
                                            <div class="learner__tab">
                                                <h6 class="learner__name">{{ learner?.gender == 1 ? 'Male' :
                                                    learner?.gender == 2 ? 'Female' : learner?.gender == 3 ? 'Other' : '-' }}</h6>
                                            </div>

                                            <!-- Subscription Status -->
                                            <div class="subscription__tab">
                                                <span v-if="learner.subscription_status === null"
                                                    class="inactive__label">No Subscription</span>
                                                <span v-else-if="learner.subscription_status"
                                                    class="active__label">Active</span>
                                                <span v-else class="inactive__label">Expired</span>
                                            </div>

                                            <!-- Progress Bar -->
                                            <div class="progress__tab"
                                                style="display: flex; gap:10px;font-weight: 500; color: #41B9FE;">
                                                <span>{{ learner?.progress ?? 0 }}%</span>
                                                <div class="progress__bar">
                                                    <span :style="{ width: (learner?.progress ?? 0) + '%' }"></span>
                                                </div>
                                            </div>

                                            <!-- Action Button -->
                                            <div class="action__tab">
                                                <div class="action__btn">
                                                    <RouterLink
                                                        :to="`organizations/${learner.organization_id}/learners/${learner.id}/dashboard`">
                                                        <span class="btn__text">View</span>
                                                        <span class="btn__arrow">
                                                            <img :src="arrowRightIcon" alt="Arrow" />
                                                        </span>
                                                    </RouterLink>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                                <div class="no__learner__box" v-else>
                                    <div class="inner__cover__box">
                                        <div class="img__box__wrapper">
                                            <img :src="kidsreadingbookImg">
                                        </div>
                                        <div class="no__learner__content__box">
                                            <h4 class="title">You Have No Active Learners</h4>
                                            <div class="no__learner__shortnote">
                                                <p>You don’t have any learners yet. To get started, either create an
                                                    organization and add learners, or ask your organization leader to
                                                    assign
                                                    learners to you.</p>
                                            </div>
                                        </div>
                                        <div class="btn__box__wrapper">
                                            <div class="purchase__learner__btn">
                                                <RouterLink to="/organizations">Go To Organizations</RouterLink>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="rlms-w-100">
                                <paginate v-model="page" :page-count="totalPages" :margin-pages="2" :prev-text="'<'"
                                    :next-text="'>'" :container-class="'pagination'" :page-class="'page-item'"
                                    :active-class="'active-page'" v-if="totalItems > 0" />
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script setup>
import learnerIcon from "@/assets/images/learner-icon.png";
import kidsreadingbookImg from "@/assets/images/kids-reading-book.png";
import { RouterLink } from "vue-router";
import api from "@/services/axios";
import { computed, onMounted, onUnmounted, ref, watch } from "vue";
import { handleError } from "@/utils/handleError";
import { useLoaderStore } from "@/stores/loader";
import { debounce } from "@/utils/debounce";
import paginate from 'vuejs-paginate-next';
import SkeletonLoader from "@/components/skeleton/SkeletonLoader.vue";
import searchIcon from '@/assets/images/search.svg'
import dangerIcon from '@/assets/images/danger.svg'
import learnMoreIcon from '@/assets/images/mob-learn-more-icon.png'
import arrowRightIcon from '@/assets/images/arrow-right.svg'
import optionsInfoIcon from '@/assets/images/options-info-icon.png';
import Tooltip from "@/components/Tooltip.vue";

const learners = ref([]);
const loader = useLoaderStore();
const page = ref(1);
const totalPages = ref(1);
const totalItems = ref(0);

// const types = ['all', 'active', 'inactive'];
const filter = ref({
    type: 'all',
    search: ''
});

const screenWidth = ref(window.innerWidth);
const isMobile = computed(() => screenWidth.value < 768);
const updateWidth = () => {
    screenWidth.value = window.innerWidth;
};

const loading = computed(() => {
    return loader.loading;
});

onMounted(() => {
    window.addEventListener('resize', updateWidth);
});

onUnmounted(() => {
    window.removeEventListener('resize', updateWidth);
});

onMounted(() => {
    init();
});


const init = () => {
    filter.value.type = 'all';
    filter.value.search = '';
    page.value = 1;

    fetchData();
}

const fetchData = async (type = filter.value.type, search = filter.value.search) => {
    try {
        loader.show();

        const { data } = await api.get(`/user/learners`, {
            params: {
                type,
                search,
                page: page.value,
                per_page: 25
            }
        });
        learners.value = data?.data?.data || [];

        totalPages.value = data?.data?.last_page ?? 1;
        totalItems.value = data?.data?.total ?? 0;

        filter.value.type = type;
        filter.value.search = search;
    } catch (error) {
        handleError(error);
    } finally {
        loader.hide();
    }
}

const handleSearch = debounce(function () {
    page.value = 1;
    fetchData(filter.value.type, filter.value.search);
}, 400);

watch(page, () => {
    fetchData();
});

</script>